import React from 'react';

export default class ChangeInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render = () => {
    const object = this.props.object;
    return (
      <div className='changeInput'>
        <input
          type='text'
          value={object.from || '-'}
          readOnly
          className='form-control'
        />
        <span>{'->'}</span>
        <input
          type='text'
          value={object.to || '-'}
          readOnly
          className='form-control'
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/ChangeInput.js